import { Link } from "react-router-dom";
import usePageMeta from "@/hooks/usePageMeta";

export default function About() {
  usePageMeta({
    title: "关于我们 - 最近中文字幕",
    description:
      "了解最近中文字幕的网站定位、内容说明与免责声明。我们专注整理最新影视中文字幕更新信息，为中文观众提供清晰的影视简介与字幕动态。",
    keywords: "最近中文字幕,关于我们,网站介绍,免责声明,影视字幕信息",
  });

  return (
    <div className="w-full">
      <section className="w-full bg-primary-950 px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/95 px-3 py-1 text-xs font-semibold text-background-50 dark:text-foreground-950">
            <i className="ri-information-line"></i>
            关于我们
          </span>
          <h1 className="mt-4 font-heading text-3xl font-black text-background-50 md:text-4xl">
            最近中文字幕
          </h1>
          <p className="mt-4 text-sm leading-relaxed text-primary-100 md:text-base">
            一个专注影视中文字幕更新信息的展示平台，帮助中文影视爱好者快速找到想看的内容。
          </p>
        </div>
      </section>

      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <article className="rounded-lg border border-background-200 bg-background-50 p-6 lg:col-span-2">
            <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
              <i className="ri-focus-3-line text-primary-600"></i>
              网站定位
            </h2>
            <div className="mt-4 space-y-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              <p>
                最近中文字幕定位为影视资源信息门户，专注整理最新影视作品的中文字幕更新动态。
                内容涵盖电影与电视剧两大类别，帮助用户按题材、年份快速筛选，并浏览作品详情与字幕说明。
              </p>
              <p>
                我们希望用清晰的信息层级与舒适的阅读体验，让查找带中文字幕的影视作品变得简单高效。
                网站内容会持续更新，逐步完善作品信息与字幕动态。
              </p>
            </div>

            <h2 className="mt-8 flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
              <i className="ri-shield-check-line text-accent-600"></i>
              免责声明
            </h2>
            <ul className="mt-4 space-y-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              <li className="flex gap-3">
                <i className="ri-checkbox-circle-line mt-0.5 text-primary-500"></i>
                本站为演示性质站点，页面中的片名、剧情、人物及字幕信息均为虚构合成数据，仅用于展示与学习交流。
              </li>
              <li className="flex gap-3">
                <i className="ri-checkbox-circle-line mt-0.5 text-primary-500"></i>
                本站不提供任何影视在线播放、下载或字幕文件下载服务，仅展示作品信息与字幕动态。
              </li>
              <li className="flex gap-3">
                <i className="ri-checkbox-circle-line mt-0.5 text-primary-500"></i>
                如相关内容的展示涉及权益问题，欢迎通过下方联系方式与我们联系，我们会及时处理。
              </li>
              <li className="flex gap-3">
                <i className="ri-checkbox-circle-line mt-0.5 text-primary-500"></i>
                收藏功能仅使用浏览器本地存储保存，清除浏览器数据后收藏记录将一并删除，且不会上传到服务器。
              </li>
            </ul>
          </article>

          <aside className="space-y-6">
            <div className="rounded-lg border border-background-200 bg-background-50 p-6">
              <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-mail-line text-accent-600"></i>
                联系方式
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                如有建议、内容反馈或合作意向，欢迎发送邮件联系我们：
              </p>
              <p className="mt-3 break-all rounded-md bg-background-100 px-3 py-2 font-mono text-sm text-foreground-900">
                feedback@zuijinzhongwen.demo
              </p>
              <p className="mt-3 text-xs text-foreground-400">
                邮箱为演示地址，仅用于展示效果。
              </p>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-50 p-6">
              <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-compass-3-line text-primary-600"></i>
                快速导航
              </h2>
              <div className="mt-4 flex flex-col gap-2">
                <Link to="/category/movie" className="flex items-center justify-between rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100">
                  电影专区
                  <i className="ri-arrow-right-s-line"></i>
                </Link>
                <Link to="/category/tv" className="flex items-center justify-between rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100">
                  电视剧专区
                  <i className="ri-arrow-right-s-line"></i>
                </Link>
                <Link to="/favorites" className="flex items-center justify-between rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100">
                  我的收藏
                  <i className="ri-arrow-right-s-line"></i>
                </Link>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}